import { useQuery } from "@tanstack/react-query";
import { ColumnFiltersState } from "@tanstack/table-core";
import { useMemo } from "react";

import { useApi } from "@/shared/api/use-api";

import { columnFiltersToHhFilters, groupingToGroupBy } from "../utils";

type UseQueryHandHistoryAggregatedParams = {
  grouping: string[];
  pageNumber: number;
  pageSize: number;
  columnFilters: ColumnFiltersState;
  columnFilterFns: Record<string, string>;
};

export const useQueryHandHistoryAggregated = ({
  grouping,
  pageNumber,
  pageSize,
  columnFilters,
  columnFilterFns,
}: UseQueryHandHistoryAggregatedParams) => {
  const { statAnalyticsApi } = useApi();

  const request = useMemo(
    () => ({
      group_by: groupingToGroupBy(grouping),
      filters: columnFiltersToHhFilters(columnFilters, columnFilterFns),
      page: {
        page_number: pageNumber,
        page_size: pageSize,
      },
    }),
    [grouping, pageNumber, pageSize, columnFilters, columnFilterFns]
  );

  return useQuery({
    queryKey: ["/mtt-analytics/hand-history-aggregated", request],
    refetchOnWindowFocus: false,
    retry: false,
    queryFn: ({ signal }) =>
      statAnalyticsApi.queryHandHistoryAggregated(request, {
        signal,
      }),
  });
};
